"use strict";

exports.__esModule = true;
exports.DeviceInfo = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _DeviceTagList = require("../DeviceTag/DeviceTagList");
var _DescriptionList = require("../../Core/DescriptionList/DescriptionList");
var _DescriptionListItem = require("../../Core/DescriptionList/DescriptionListItem");
var _YesNo = require("../../Core/YesNo");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var DeviceInfoView = _styledComponents["default"].article.withConfig({
  displayName: "DeviceInfo__DeviceInfoView",
  componentId: "sc-1s4bg3o-0"
})(["display:flex;flex-direction:column;"]);
var DeviceInfoHeader = _styledComponents["default"].header.withConfig({
  displayName: "DeviceInfo__DeviceInfoHeader",
  componentId: "sc-1s4bg3o-1"
})(["display:flex;flex-direction:row;"]);
var DeviceInfoTitle = _styledComponents["default"].h1.withConfig({
  displayName: "DeviceInfo__DeviceInfoTitle",
  componentId: "sc-1s4bg3o-2"
})(["flex:1;"]);
var DeviceExpandCollapseButton = _styledComponents["default"].button.withConfig({
  displayName: "DeviceInfo__DeviceExpandCollapseButton",
  componentId: "sc-1s4bg3o-3"
})(["margin-left:auto;border:none;background:transparent;"]);

/**
 * Displays information about an individual device.
 */
var DeviceInfo = exports.DeviceInfo = /*#__PURE__*/function (_Component) {
  function DeviceInfo() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      isOpen: false
    };
    _this.handleToggleClick = function () {
      _this.setState(Object.assign({}, _this.state, {
        isOpen: !_this.state.isOpen
      }));
    };
    return _this;
  }
  _inheritsLoose(DeviceInfo, _Component);
  var _proto = DeviceInfo.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var device = this.props.device;
    var isOpen = this.state.isOpen;
    return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
      var translate = _ref.translate;
      return /*#__PURE__*/_react["default"].createElement(DeviceInfoView, null, /*#__PURE__*/_react["default"].createElement(DeviceInfoHeader, null, /*#__PURE__*/_react["default"].createElement(DeviceInfoTitle, null, device.name, " ", /*#__PURE__*/_react["default"].createElement("small", null, device.uuid)), /*#__PURE__*/_react["default"].createElement(DeviceExpandCollapseButton, {
        onClick: _this2.handleToggleClick
      }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
        icon: isOpen ? _icons.IconNames.CHEVRON_UP : _icons.IconNames.CHEVRON_DOWN,
        title: isOpen ? translate("DeviceInfo.collapsed.icon.title", "Collapse") : translate("DeviceInfo.expanded.icon.title", "Expand"),
        size: 64,
        intent: "primary"
      }))), /*#__PURE__*/_react["default"].createElement(_DeviceTagList.DeviceTagList, {
        values: device.tags
      }), /*#__PURE__*/_react["default"].createElement(_core.Collapse, {
        isOpen: isOpen
      }, /*#__PURE__*/_react["default"].createElement(_DescriptionList.DescriptionList, null, /*#__PURE__*/_react["default"].createElement(_DescriptionListItem.DescriptionListItem, {
        term: translate("DeviceInfo.enabled.label", "Device Enabled")
      }, /*#__PURE__*/_react["default"].createElement(_YesNo.YesNo, {
        value: device.enabled
      })), /*#__PURE__*/_react["default"].createElement(_DescriptionListItem.DescriptionListItem, {
        term: translate("DeviceInfo.allowProducing.label", "Device Allows Producing")
      }, /*#__PURE__*/_react["default"].createElement(_YesNo.YesNo, {
        value: device.allowProducing
      })), /*#__PURE__*/_react["default"].createElement(_DescriptionListItem.DescriptionListItem, {
        term: translate("DeviceInfo.currentCycleClassify.label", "Classify Current Cycle")
      }, device.currentCycleClassify))));
    });
  };
  return DeviceInfo;
}(_react.Component);